/* MT/26 — account pages: login/recover toggle, address modals + provinces, reorder, delete confirm */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function q(s, sc) { return (sc || document).querySelector(s); }
  function qa(s, sc) { return Array.prototype.slice.call((sc || document).querySelectorAll(s)); }
  /* login / recover panes */
  var auth = q('[data-mt-auth]');
  function showPane(name) { if (!auth) return; qa('[data-mt-auth-pane]', auth).forEach(function (p) { p.hidden = p.dataset.mtAuthPane !== name; }); var f = q('[data-mt-auth-pane]:not([hidden]) input', auth); if (f) setTimeout(function () { f.focus(); }, 40); }
  if (auth) {
    if (location.hash === '#recover' || q('[data-mt-recover-ok]', auth)) showPane('recover');
    document.addEventListener('click', function (e) { var g = e.target.closest('[data-mt-auth-go]'); if (g) { e.preventDefault(); showPane(g.dataset.mtAuthGo); history.replaceState({}, '', '#' + g.dataset.mtAuthGo); } });
  }
  /* address modals */
  function closeModal(m) { if (!m) return; m.hidden = true; document.body.style.overflow = ''; if (window.MT && MT.releaseFocus) MT.releaseFocus(m); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mt-addr-open]');
    if (o) { var m = q('[data-mt-addr-modal="' + o.dataset.mtAddrOpen + '"]'); if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; qa('[data-mt-country]', m).forEach(initCountry); if (window.MT && MT.trapFocus) MT.trapFocus(m, { initialSelector: '.mt-modal__close', opener: o }); } }
    var c = e.target.closest('[data-mt-modal-close]');
    if (c) closeModal(c.closest('.mt-modal'));
    var d = e.target.closest('[data-confirm]'); if (d && !window.confirm(d.dataset.confirm)) { e.preventDefault(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') qa('.mt-modal:not([hidden])').forEach(closeModal); });
  /* provinces from Shopify's country option tags (data-provinces on each <option>) */
  function initCountry(sel) {
    if (sel.dataset.ready) return; sel.dataset.ready = '1';
    var wrap = sel.closest('form'); var prov = q('[data-mt-province]', wrap), pw = q('[data-mt-province-wrap]', wrap);
    var def = sel.dataset.default; if (def) { qa('option', sel).forEach(function (op) { if (op.value === def || op.textContent === def) op.selected = true; }); }
    function fill() {
      var opt = sel.options[sel.selectedIndex]; var list = []; try { list = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
      if (!prov) return;
      prov.innerHTML = list.map(function (p) { return '<option value="' + p[0] + '"' + (p[0] === prov.dataset.default || p[1] === prov.dataset.default ? ' selected' : '') + '>' + p[1] + '</option>'; }).join('');
      if (pw) pw.hidden = list.length === 0;
    }
    sel.addEventListener('change', fill); fill();
  }
  qa('[data-mt-country]').forEach(initCountry);
  /* all-collections: active tab on scroll */
  var lcTabs = qa('[data-mt-lc-tabs] a');
  if (lcTabs.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) lcTabs.forEach(function (t) { t.classList.toggle('mt-on', t.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-25% 0px -60% 0px' });
    qa('.mt-lc__group[id], .mt-lc__weights[id], .mt-lc__all[id]').forEach(function (g) { io.observe(g); });
  }
  /* reorder */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mt-reorder]'); if (!b) return;
    var items = []; try { items = JSON.parse(b.dataset.mtReorder); } catch (err) {}
    items = items.filter(function (i) { return i.id; }); if (!items.length) return;
    b.classList.add('mt-loading'); b.disabled = true;
    var done = function () { b.classList.remove('mt-loading'); b.disabled = false; };
    if (window.MT && MT.cartAdd) MT.cartAdd(items).then(done).catch(done);
    else fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function () { location.href = root + 'cart'; }).catch(done);
  });
})();
